// 商机管理
const Clue = () => import('@/pages/clue/index.vue');

const arr = [
  // 商机管理
  {
    path: '/clue',
    name: 'clue',
    component: Clue,
    meta: {
      auth: false,
    },
  },
];

export default arr;
